import { Box, Stack } from "@mui/material";
import RobertAndSusan from "../../../assets/our-homeowners-page/robert-and-susan.jpg";
import samanthaR from "../../../assets/our-homeowners-page/Samantha R.jpg";
import laurenM from "../../../assets/our-homeowners-page/Lauren M.jpg";
import danielAndMiguel from "../../../assets/our-homeowners-page/Daniel F. & Miguel R.jpg";
import ethanR from "../../../assets/our-homeowners-page/Ethan R.jpg";
import jordanAndAlexis from "../../../assets/our-homeowners-page/Jordan & Alexis B.jpg";
import oliviaM from "../../../assets/our-homeowners-page/Olivia M.jpg";

import { PersonaCard, PersonaCardProps } from "./persona-card";

const personaCards: PersonaCardProps[] = [
  {
    title: "Robert & Susan C.",
    subtitle: "Empty Nesters, Seeking Sophistication & Style ",
    tags: ["Coastal Style", "Urban"],
    description:
      "Robert (62) and Susan (60) are affluent, design-savvy empty nesters looking to transform their historic Charleston home into a sophisticated yet comfortable retreat. With Susanâ€™s background in event planning, she has a keen eye for style and values carefully curated interiors that reflect elegance and individuality. They seek an interior designer who can blend coastal style with modern functionality while incorporating high-end materials, sustainability, and a refined aesthetic that aligns with their love for travel and luxury design.",
    image: RobertAndSusan,
  },
  {
    title: "Samantha R.",
    subtitle: "Busy Professional, Seeking Authenticity & Ease",
    tags: ["Modern Style", "Suburban"],
    description:
      "Samantha is a 38-year-old professional with an eye for design, but limited time to handle all the details of creating her dream home. Samantha values high-quality, modern design and is willing to invest in creating a home that reflects her personal tastes. Sheâ€™s tech-savvy, eco-conscious, and loves keeping up with interior design trends. She seeks an interior designer who can deliver both style and functionality with minimal hassle. ",
    image: samanthaR,
  },
  {
    title: "Lauren M.",
    subtitle: "Family-Focused, Seeking Style with Structure",
    tags: ["Transitional Style", "Suburban"],
    description:
      "Lauren is a 42-year-old stay-at-home mom to four kids, balancing a busy family life while striving to create a beautiful, functional, and peaceful home. Although she has a clear sense of style, she struggles with the overwhelming amount of choices and the time it takes to make decisions. With a busy surgeon husband, Lauren is looking for a designer who can simplify the process and help create a space that feels curated yet welcoming, a place where her family can thrive. ",
    image: laurenM,
  },
  {
    title: "Daniel F. & Miguel R.",
    subtitle: "Newly Weds, Seeking Style Integration",
    tags: ["Mid Century Modern", "Urban"],
    description:
      "Daniel (44) and Miguel (39) are a stylish, design-conscious couple who value sustainability, luxury, and personalization. They seek an interior designer who can bring a curated, high-end yet comfortable aesthetic to their home while incorporating smart technology and eco-friendly materials. Their home needs to reflect their sophisticated tastes while being functional for entertaining and daily living.",
    image: danielAndMiguel,
  },
  {
    title: "Ethan R.",
    subtitle: "Successful Professional, Seeking Modern Luxury",
    tags: ["Contemporary Style", "Urban"],
    description:
      "Ethan is a 43-year-old, high-achieving, single professional who wants his home to reflect his success while remaining functional and low-maintenance. He values a sleek, modern aesthetic with smart technology and high-end finishes. He seeks an interior designer who can create a refined, masculine space that feels both luxurious and efficient.",
    image: ethanR,
  },
  {
    title: "Jordan & Alexis B.",
    subtitle: "First Home, Seeking Personalization & Warmth",
    tags: ["Modern Farmhouse", "Suburban"],
    description:
      "Jordan (32) and Alexis (30) are first-time millennial homebuyers excited to personalize their new space. They value modern, functional design with a touch of warmth and personality. While they want professional guidance to achieve their vision, they also enjoy being hands-on in the process. They seek an interior designer who can create a stylish yet budget-friendly home that balances aesthetics with practicality.",
    image: jordanAndAlexis,
  },
  {
    title: "Olivia M.",
    subtitle: "Global Jet Setter, Seeking Curated Retreat",
    tags: ["Traditional Style", "Suburban"],
    description:
      "Olivia is 51-year-old independent, career-driven woman who values a home that feels like a work of art. She seeks an interior designer who can curate a sophisticated, globally inspired space that blends creativity, comfort, and sustainability. Her home must serve as both a writing retreat and a gathering place for close friends, reflecting her rich life experiences.",
    image: oliviaM,
  },
];

export const PersonaCards = () => {
  return (
    <div className="site-wrapper">
      <Stack direction="row" spacing={2}>
        {personaCards.map((card) => (
          <PersonaCard key={card.title} {...card} />
        ))}
      </Stack>
    </div>
  );
};